import React from 'react';
import { observer } from 'mobx-react-lite';

import { AutoBetSection } from '../../../components/autoBetSection';
import { AutoCashOutSection } from '../../../components/autoCashOutSection';

export const AutoBetAutoCashOutSection = observer(
  ({
    t,
    isDemo,
    isStart,
    maxWin,
    betAmount,
    fighterData,
    autoBetData,
    doBetSender,
    isAutoCashOut,
    activeFreeBet,
    autoCashOutOdd,
    handleOpenNumPad,
    handleChangeAutoBet,
    currentFighterSection,
    handleSwitchAutoCashOut,
    isDisabledFighterSection,
    updateIsDisabledBetSection,
    handleChangeAutoCashOutInput,
    handleChangeAutoCashOutInputValue,
  }) => {
    return (
      <div className={`bet-left-container ${fighterData.isNextRoundBet ? 'passive' : ''}`}>
        <div className='inner-bet-left-container'>
          <AutoCashOutSection
            t={t}
            maxWin={maxWin}
            betAmount={betAmount}
            fighterData={fighterData}
            autoBetData={autoBetData}
            isAutoCashOut={isAutoCashOut}
            activeFreeBet={activeFreeBet}
            autoCashOutOdd={autoCashOutOdd}
            handleOpenNumPad={handleOpenNumPad}
            currentFighterSection={currentFighterSection}
            handleSwitchAutoCashOut={handleSwitchAutoCashOut}
            isDisabledFighterSection={isDisabledFighterSection}
            handleChangeAutoCashOutInput={handleChangeAutoCashOutInput}
            handleChangeAutoCashOutInputValue={handleChangeAutoCashOutInputValue}
          />
          <AutoBetSection
            t={t}
            isDemo={isDemo}
            isStart={isStart}
            fighterData={fighterData}
            autoBetData={autoBetData}
            doBetSender={doBetSender}
            handleChangeAutoBet={handleChangeAutoBet}
            currentFighterSection={currentFighterSection}
            isDisabledFighterSection={isDisabledFighterSection}
            updateIsDisabledBetSection={updateIsDisabledBetSection}
          />
        </div>
      </div>
    );
  }
);
